import { render, staticRenderFns } from "./black-item.vue?vue&type=template&id=17caf8d8&scoped=true"
import script from "./black-item.vue?vue&type=script&lang=ts"
export * from "./black-item.vue?vue&type=script&lang=ts"
import style0 from "./black-item.vue?vue&type=style&index=0&id=17caf8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17caf8d8",
  null
  
)

export default component.exports